import { render, staticRenderFns } from "./salesChart.vue?vue&type=template&id=6f055de6&scoped=true"
import script from "./salesChart.vue?vue&type=script&lang=js"
export * from "./salesChart.vue?vue&type=script&lang=js"
import style0 from "./salesChart.vue?vue&type=style&index=0&id=6f055de6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f055de6",
  null
  
)

export default component.exports